import React, { Suspense, lazy } from 'react';
import Layout from './components/layout/Layout';
import HeroSection from './components/sections/HeroSection/index';
import SolutionSection from './components/sections/SolutionSection/index';
import ProblemSection from './components/sections/ProblemSection/index';
// import AmplificationSection from './components/sections/AmplificationSection/index';
// import CaseSection from './components/sections/CaseSection/index';
// import ComparisonSection from './components/sections/ComparisonSection/index';
// import TestimonialsSection from './components/sections/TestimonialsSection/index';
// import FaqSection from './components/sections/FaqSection/index';

const AmplificationSection = lazy(() => import('./components/sections/AmplificationSection/index'));
const CaseSection = lazy(() => import('./components/sections/CaseSection/index'));
const ComparisonSection = lazy(() => import('./components/sections/ComparisonSection/index'));
const TestimonialsSection = lazy(() => import('./components/sections/TestimonialsSection/index'));
const FaqSection = lazy(() => import('./components/sections/FaqSection/index'));

function App() {
  // Valor padrão para a calculadora
  const valorSlider = 3000;
  // Valor arredondado para múltiplos de 20
  const valorSliderVisual = Math.round(valorSlider / 20) * 20;

  return (
    <Layout>
      <HeroSection />
      <SolutionSection />
      <div className="section-divider">
        <svg 
          viewBox="0 0 1920 200" 
          xmlns="http://www.w3.org/2000/svg" 
          preserveAspectRatio="none"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        >
          <path d="M1920 0H0V200H1920V0Z" fill="#FEFEFE"/>
          <path d="M0 47L960 180L1920 44V200H960H0V47Z" fill="#003366"/>
        </svg>
      </div>
      <ProblemSection />
      <div className="section-divider">
        <svg 
          viewBox="0 0 1920 200" 
          xmlns="http://www.w3.org/2000/svg" 
          preserveAspectRatio="none"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block'
          }}
        >
          <rect x="0" y="0" width="1920" height="200" fill="#003366"/>
          <path d="M0 48L960 181L1920 45L1920 201L960 201L0 201Z" fill="#002244"/>
        </svg>
      </div>
      <Suspense fallback={<div>...</div>}>
        <AmplificationSection />
        <div className="section-divider">
          <svg 
            viewBox="0 0 1920 200" 
            xmlns="http://www.w3.org/2000/svg" 
            preserveAspectRatio="none"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          >
            <path d="M1920 0H0V200H1920V0Z" fill="#002244"/>
            <path d="M0 47L960 180L1920 44V200H960H0V47Z" fill="#003366"/>
          </svg>
        </div>
        <CaseSection />
        <div className="section-divider">
          <svg 
            viewBox="0 0 1920 200" 
            xmlns="http://www.w3.org/2000/svg" 
            preserveAspectRatio="none"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          >
            <rect x="0" y="0" width="1920" height="200" fill="#003366"/>
            <path d="M0 48L960 181L1920 45L1920 201L960 201L0 201Z" fill="#002244"/>
          </svg>
        </div>
        <ComparisonSection />
        <div className="section-divider">
          <svg 
            viewBox="0 0 1920 200" 
            xmlns="http://www.w3.org/2000/svg" 
            preserveAspectRatio="none"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          >
            <path d="M0 43L160 52.7C320 62.3 640 81.7 960 83.3C1280 85 1600 69 1760 61L1920 53L1920 0L1760 0C1600 0 1280 0 960 0C640 0 320 0 160 0L0 0Z" fill="#002244"/>
            <path d="M0 97L160 105.7C320 114.3 640 131.7 960 130C1280 128.3 1600 107.7 1760 97.3L1920 87L1920 51L1760 59C1600 67 1280 83 960 81.3C640 79.7 320 60.3 160 50.7L0 41Z" fill="#31636e"/>
            <path d="M0 167L160 170.3C320 173.7 640 180.3 960 174.3C1280 168.3 1600 149.7 1760 140.3L1920 131L1920 85L1760 95.3C1600 105.7 1280 126.3 960 128C640 129.7 320 112.3 160 103.7L0 95Z" fill="#8ea398"/>
            <path d="M0 201L160 201C320 201 640 201 960 201C1280 201 1600 201 1760 201L1920 201L1920 129L1760 138.3C1600 147.7 1280 166.3 960 172.3C640 178.3 320 171.7 160 168.3L0 165Z" fill="#e6e5e0"/>
          </svg>
        </div>
        <FaqSection />
        <div className="section-divider">
          <svg 
            viewBox="0 0 1920 200" 
            xmlns="http://www.w3.org/2000/svg" 
            preserveAspectRatio="none"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          >
            <rect x="0" y="0" width="1920" height="200" fill="#E6E5E0"/>
            <path d="M0 18L80 26.3C160 34.7 320 51.3 480 51.7C640 52 800 36 960 29.7C1120 23.3 1280 26.7 1440 26.3C1600 26 1760 22 1840 20L1920 18L1920 201L1840 201C1760 201 1600 201 1440 201C1280 201 1120 201 960 201C800 201 640 201 480 201C320 201 160 201 80 201L0 201Z" fill="#00366d"/>
            <path d="M0 131L80 130.2C160 129.3 320 127.7 480 124.8C640 122 800 118 960 109.2C1120 100.3 1280 86.7 1440 90.5C1600 94.3 1760 115.7 1840 126.3L1920 137L1920 201L1840 201C1760 201 1600 201 1440 201C1280 201 1120 201 960 201C800 201 640 201 480 201C320 201 160 201 80 201L0 201Z" fill="#082751"/>
            <path d="M0 128L80 137.5C160 147 320 166 480 172.5C640 179 800 173 960 164.3C1120 155.7 1280 144.3 1440 144.7C1600 145 1760 157 1840 163L1920 169L1920 201L1840 201C1760 201 1600 201 1440 201C1280 201 1120 201 960 201C800 201 640 201 480 201C320 201 160 201 80 201L0 201Z" fill="#091936"/>
          </svg>
        </div>
        <TestimonialsSection valorInicialCalculadora={valorSliderVisual} />
      </Suspense>
    </Layout>
  );
}

export default App;
